import { I18n } from '@calendly/i18n'
import { AdminIcon } from '@calendly/ui/components/icons'

import { Banner } from './banner'

export const NonAdminBanner = () => (
  <Banner
    Icon={AdminIcon}
    text={I18n.t('publisher.upgrade_banner.non_admin_text')}
  />
)
